import React, { useEffect } from "react";

import { fetchUserInfo, updateUserInfo, setUserInfoLocal } from "../../../redux/actions/userActions";
import { fetchOrganizationInfo } from "../../../redux/actions/organizationActions";
import { useDispatch, useSelector } from "react-redux";
import GeneralForm from "./GeneralForm";

const GeneralParameters = ({}) => {
  // REDUX
  const dispatch = useDispatch();
  const fetchUserInfo_rd = () => dispatch(fetchUserInfo());
  const setUserInfoLocal_rd = (item) => dispatch(setUserInfoLocal(item));
  const updateUserInfo_rd = (item) => dispatch(updateUserInfo(item));
  const fetchOrganizationInfo_rd = (item) => dispatch(fetchOrganizationInfo(item));
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const organization_info = useSelector((state) => (state.organization.organization_info ? state.organization.organization_info : null));

  useEffect(() => {
    async function fetch_fn() {
      fetchUserInfo_rd();
      fetchOrganizationInfo_rd();
    }
    // if (!user_info) {
      fetch_fn();
    // }
  }, []);

  const onSumbit = (item) => {
    setUserInfoLocal_rd(item);
    updateUserInfo_rd(item);
  };

  return (
    <>
      <div className="w-full flex justify-center items-center h-[60px]">
        <div className="w-[900px] h-full border-b-[1px] border-black flex justify-start items-center">
          <p className="text-xl font-Poppins-SemiBold">Information</p>
        </div>
      </div>
      <div className="w-full flex justify-center mt-[10px]">
        <div className="w-[600px]">
          <GeneralForm onSubmit={onSumbit} />
        </div>
      </div>
    </>
  );
};

export default GeneralParameters;
